<template>
  <div class="multi-datepicker">
    <div class="multi-datepicker-item" v-for="(item,index) in dateArray" :key="index">
      <div class="datepicker-box">
        <a-date-picker :allowClear="false" :placeholder="config.placeholder?config.placeholder:'请选择日期'" v-model="dateArray[index].date" @change="(date, dateString)=>onDateChange(date, dateString,index)" :class="isNomalDate(dateArray[index].date,config.compare)?'':'warn'" />
        <div class="handle plus-handle" v-if="dateArray.length>1" @click="minus(index)">-</div>
        <div class="handle minus-handle" v-if="index===dateArray.length-1" @click="plus">+</div>
      </div>
      <div class="hasWarn" v-if="config.compare && !isNomalDate(dateArray[index].date,config.compare)">{{config.compare.message}}</div>
    </div>
  </div>
</template>

<script>
import LayoutConfig from '../utils/LayoutConfig.js';
import moment from 'moment';

export default {
  components: {},
  props: {
    params: Array,
    config: Object,
  },
  data() {
    return {
      dateArray: [],
    };
  },
  methods: {
    minus(index) {
      this.dateArray.splice(index, 1);
      this.$emit(
        'get-multidate',
        this.dateArray
          .map(item => {
            return item.date
              ? moment(item.date).format('YYYY-MM-DD')
              : undefined;
          })
          .filter(e => e !== undefined),
      );
    },
    plus() {
      const dateTem = _.cloneDeep({
        date: undefined,
      });
      this.dateArray.push(dateTem);
      this.$emit(
        'get-multidate',
        this.dateArray
          .map(item => {
            return item.date
              ? moment(item.date).format('YYYY-MM-DD')
              : undefined;
          })
          .filter(e => e !== undefined),
      );
    },
    onDateChange(date, dateString, index) {
      const dates = this.dateArray.map(item => {
        return item.date ? moment(item.date).format('YYYY-MM-DD') : undefined;
      });
      if (dates.filter(item => item && item === dateString).length > 1) {
        this.$Message.warn('日期不可重复选择');
        this.dateArray[index].date = undefined;
      }
      this.isNomalDate(date, this.config.compare);
      this.$emit(
        'get-multidate',
        this.dateArray
          .map(item => {
            return item.date
              ? moment(item.date).format('YYYY-MM-DD')
              : undefined;
          })
          .filter(e => e !== undefined),
      );
    },
    isNomalDate(selectedDate, compare) {
      return LayoutConfig.isNomalDate(selectedDate, compare);
    },
  },
  watch: {
    params: {
      handler(val) {
        if (val.length === 0) {
          this.$set(this.dateArray, 0, { date: undefined });
        } else {
          val.forEach((item, index) => {
            this.$set(this.dateArray, index, { date: moment(item) });
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less">
.multi-datepicker {
  &-item {
    margin-bottom: 16px;

    > div.datepicker-box {
      width: 100%;
      display: flex;
    }
    .hasWarn {
      font-size: 14px;
      color: #ff9500;
    }

    .ant-calendar-picker {
      width: calc(100% - 86px);
      margin-right: 16px;
    }
    .ant-calendar-picker.warn .ant-input {
      border: 1px solid #e54506;
      border-radius: 4px;
    }
    .ant-calendar-picker.warn .anticon-calendar {
      color: #e54506;
    }
    .handle {
      height: 30px;
      width: 30px;
      line-height: 30px;
      border-radius: 3px;
      border: 1px solid #d9d9d9;
      font-weight: bold;
      text-align: center;
      cursor: pointer;
    }
    .plus-handle {
      margin-right: 8px;
    }
  }
  &-item:last-child {
    margin-bottom: 0;
  }
}
</style>
